import React, { useState, useEffect } from 'react';
import PlaceholderImage from "../resources/elementor-placeholder-image.webp";
import { doc, setDoc } from "firebase/firestore"; 
import { db, storage } from "../firebase/firebaseConfig";
import {
  getDownloadURL,
  ref as storageRef,
  uploadBytes,
} from "firebase/storage";
import { useNavigate } from 'react-router-dom';
import NewPlaceholderImage from "../resources/new-placeholder.jpg"

const CreateMember = (e) => {
  const navigate = useNavigate();
  
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [area, setArea] = useState("");
  const [campus, setCampus] = useState("");
  const [featuredImage, setFeaturedImage] = useState(null); 
  const [placeholderImage, setPlacholderImage] = useState(NewPlaceholderImage);

  const generateId = () => {
    return [...Array(20)].map(() => Math.random().toString(36)[2]).join('');
  };

  const uploadImage = () => {
    return new Promise((resolve, reject) => {
      const imageRef = storageRef(storage, `${generateId()}`);

      uploadBytes(imageRef, featuredImage)
        .then((snapshot) => {
          console.log("Image uploaded successfully");

          getDownloadURL(snapshot.ref)
            .then((url) => {
              console.log("Download URL: ", url);
              resolve(url); 
            })
            .catch((error) => {
              console.error("Error getting download URL: ", error);
              reject(error); 
            });
        })
        .catch((error) => {
          console.error("Error uploading image: ", error);
          reject(error); 
        });
    });
  };

  const createMyGroup = async (e) => {
    e.currentTarget.innerHTML = "Creating Member...";
    e.target.style.cursor = "wait";

    const id = generateId();

    try {
      const imageUrl = await uploadImage();

      await setDoc(doc(db, "Members", id), {
        Name: name,
        Surname: surname,
        Email: email,
        Area: area,
        Campus: campus,
        FeaturedImage: imageUrl,
      });

      console.log("Member successfully created!");

    } catch (error) {
      console.error("Error creating member: ", error);
    }

    navigate('/members');
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setPlacholderImage(URL.createObjectURL(file));
    setFeaturedImage(file);
  };

  return (
    <div id='content'>
      <h1>Create Group</h1>
        <div className='row'>
            <div className='col-sm-8'>
                  <h4>Basic Info</h4>
                    <div className='row'>
                      <div className='col-sm-6'>
                        <label>Name
                        <br/> <input type="text" onChange={(e) => setName(e.target.value)}/></label>
                      </div>
                      <div className='col-sm-6'>
                        <label>Surname
                        <br/> <input type="text" onChange={(e) => setSurname(e.target.value)}/></label>
                      </div>
                    </div>

                    <label>Email Address
                    <br/> <input type="email" onChange={(e) => setEmail(e.target.value)}/></label>
                    <label>Area of Residence
                    <br/> <input type="text" onChange={(e) => setArea(e.target.value)}/></label>
                    <label>Campus
                    <br/> <input type="text" onChange={(e) => setCampus(e.target.value)}/></label>

                    <br/>
                    <br/>
                    <br/>
                    
                <div style={{display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-start'}}>
                    <button onClick={(e) => createMyGroup(e)}>Create Member</button>
                </div>
            </div>
            <div className='col-sm-4' style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', paddingRight: '50px'}}>
                <img src={placeholderImage} width="75%"/>
                <label style={{ cursor: 'pointer', textAlign: 'right'}}  htmlFor="file-upload" className="custom-file-upload">
                    <b>Change Featured Image</b>
                </label>
                <input
                    id="file-upload"
                    type="file"
                    onChange={handleImageChange}
                    style={{ display: 'none' }} 
                />
            </div>
        </div>
    </div>
  );
}

export default CreateMember;
